import React from 'react';

import {Icon, Text} from '@albert-io/atomic';
import type {IconProp} from '@albert-io/atomic/atoms/Icon/Icon.react';

interface Props {
  copy: string;
  icon?: IconProp;
  subtitle?: string;
}

export default function TabEmptyState({copy, icon, subtitle}: Props) {
  return (
    <div className='flex flex-col items-center justify-center gap-x2 rounded-x1 border border-primary p-x4'>
      {icon && (
        <div className='flex h-x8 w-x8 items-center justify-center rounded-full background-bold p-x1-half'>
          <Icon className='text-xxl' color='tertiary' icon={icon} />
        </div>
      )}
      <Text color='secondary'>{copy}</Text>
      {subtitle && (
        <Text color='secondary' className='max-w-[48ch] text-center text-balance'>
          {subtitle}
        </Text>
      )}
    </div>
  );
}
